import _extends from "@babel/runtime/helpers/esm/extends";
// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY

import * as React from 'react';
import LinuxOutlinedSvg from "@ant-design/icons-svg/es/asn/LinuxOutlined";
import AntdIcon from "../components/AntdIcon";
var LinuxOutlined = function LinuxOutlined(props, ref) {
  return /*#__PURE__*/React.createElement(AntdIcon, _extends({}, props, {
    ref: ref,
    icon: LinuxOutlinedSvg
  }));
};
if (process.env.NODE_ENV !== 'production') {
  LinuxOutlined.displayName = 'LinuxOutlined';
}
export default /*#__PURE__*/React.forwardRef(LinuxOutlined);